<template>
    <div>
        <div class="">
            <div class="faq-wrap">
                <div class="card-box"
                    style="padding-left: 20px;padding-right: 20px;padding-bottom: 10px;padding-top: 20px;">
                    <div class="card-header">
                        <div class="clearfix">
                            <div class="pull-left">
                                <h4 class="text-black h4">Cadastro de bairros</h4>
                            </div>
                        </div>
                    </div>
                    <v-form>
                        <v-container>
                            <v-row>
                                <v-col cols="12" md="4" v-show="false">
                                    <v-text-field v-model="Bairro.baiId" label="Id" variant="underlined"></v-text-field>
                                </v-col>
                                <v-col cols="12" md="4" v-if="Paises.length > 0">
                                    <v-select v-model="Bairro.cpaId" label="Paises" :items="Paises" @update:modelValue="CarregaEstados(Bairro.cpaId)"
                                        item-title="cpaNome" item-value="cpaId" variant="underlined">
                                    </v-select>
                                </v-col>
                                <v-col cols="12" md="4">
                                    <v-select v-model="Bairro.cetId" label="Estados" :items="Estados" @update:modelValue="CarregaCidades(Bairro.cetId)"
                                        item-title="cetNome" item-value="cetId" variant="underlined">
                                    </v-select>
                                </v-col>
                                <v-col cols="12" md="4">
                                    <v-select v-model="Bairro.cidId" label="Cidades" :items="Cidades"
                                        item-title="cidNome" item-value="cidId" variant="underlined">
                                    </v-select>
                                </v-col>
                                <v-col cols="12" md="6">
                                    <v-text-field v-model="Bairro.baiNome"
                                        label="Nome" variant="underlined" required></v-text-field>
                                </v-col>
                                <v-col cols="12" md="2">
                                    <v-select v-model="Bairro.baiAtivo" label="Ativo" :items="StatusAtivo"
                                        item-title="nome" item-value="baiAtivo" variant="underlined">
                                    </v-select>
                                </v-col>
                                <v-col cols="12" md="4">
                                    <v-text-field v-model="Bairro.baiZona"
                                        label="Zona" variant="underlined" required></v-text-field>
                                </v-col>
                            </v-row>
                        </v-container>
                    </v-form>
                    <form>
                        <div class="row">
                            <div class="col-md-12 text-center">
                                <button type="button" @click="Limpar()" class="btn btn-link">
                                    Cancelar
                                </button>
                                <button v-if="Bairro.baiId != 0" type="button" class="btn btn-success" @click="Put()">
                                    Alterar
                                </button>
                                <button v-else type="button" class="btn btn-success" @click="Add()">
                                    Salvar
                                </button>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>
        <div class="">
            <div class="faq-wrap">
                <div class="card-box" style="padding-left: 20px;padding-right: 20px;padding-bottom: 10px;margin-top: 20px;">
                    <v-container>
                        <v-row>
                            <v-col cols="12" md="4">
                                <v-text-field v-model="searchValue" label="Pesquisa" variant="underlined"
                                    required></v-text-field>
                            </v-col>
                        </v-row>
                    </v-container>
                    <easy-data-table :headers="headers" :items="Bairros" v-model="itemsSelected" alternating
                        theme-color="#364f66" table-class-name="customize-table" header-text-direction="center"
                        body-text-direction="center" rows-per-page-message="Linhas por pagina" :search-value="searchValue">
                        <template #item-baiAtivo="item">
                            <span>{{ item.baiAtivo ? 'Sim' : 'Não' }}</span>
                        </template>
                        <template #item-actions="item">
                            <v-btn icon @click="EditGrid(item)" style="margin-right: 10px;" variant="text">
                                <v-icon>mdi-file-edit-outline</v-icon>
                                <v-tooltip activator="parent" location="top">Editar</v-tooltip>
                            </v-btn>

                            <v-btn icon @click="DeleteGrid(item)" variant="text">
                                <v-icon>mdi-delete-forever-outline</v-icon>
                                <v-tooltip activator="parent" location="top">Excluir</v-tooltip>
                            </v-btn>
                        </template>
                    </easy-data-table>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import axios from 'axios';
import EasyDataTable from 'vue3-easy-data-table';
export default {
    name: 'CadastroBairrosView',
    components: {
        EasyDataTable
    },
    data: () => ({
        Bairro: {
            baiId: 0,
            baiNome: '',
            baiZona: '',
            baiAtivo: '',
            cidId: '',
            cetId: '',
            cpaId: '',
        },
        Bairros: [],
        Cidades: [],
        Estados: [],
        Paises: [],
        StatusAtivo: [{ nome: "Sim", baiAtivo: true }, { nome: "Não", baiAtivo: false }],
        headers: [
            { text: "Id", value: "baiId", sortable: true, },
            { text: "Zona", value: "baiZona", sortable: true, },
            { text: "Nome", value: "baiNome", sortable: true, },
            { text: "Ativo", value: "baiAtivo", sortable: true, },
            { text: "Zona Cidade", value: "cadCidades.cidZona", sortable: true, },
            { text: "Cidade", value: "cadCidades.cidNome", sortable: true, },
            { text: "Estado", value: "cadCidades.cadEstados.cetNome", sortable: true, },
            { text: "Pais", value: "cadCidades.cadEstados.cadPaises.cpaNome", sortable: true, },
            { text: 'Ações', value: 'actions' }
        ],
        itemsSelected: [],
        selectedItem: null,
        selectedPaises:null,
        selectedEstados:null,
        selectedCidades:null,
        searchValue: '',
    }),
    methods: {
        Limpar() {
            this.Bairro.baiId = 0;
            this.Bairro.baiNome = '';
            this.Bairro.baiZona = '';
            this.Bairro.baiAtivo = '';
            this.Bairro.cidId = '';
            this.Bairro.cetId = '';
            this.Bairro.cpaId = '';
            this.selectedPaises = null;
            this.selectedEstados = null,
            this.selectedCidades = null;
            this.Get();
        },
        Add() {
            if (this.Bairro.baiNome == '') {
                this.$mensagemAviso("Nome Obrigatório.")
            }
            else if (this.Bairro.cpaId == ''){
                this.$mensagemAviso("País Obrigatório.")
            }
            else if (this.Bairro.cetId == ''){
                this.$mensagemAviso("Estado Obrigatório.")
            }
            else if (this.Bairro.cidId == ''){
                this.$mensagemAviso("Cidade Obrigatório.")
            }
            else {
                this.Bairro.CadCidades = { cidId: this.Bairro.cidId};
                if (this.Bairro.baiAtivo === "" || this.Bairro.baiAtivo === null){
                    this.Bairro.baiAtivo = true;
                }
                axios.post(`/Process/CadBairros/Add`, this.Bairro)
                    .then(response => {
                        if (response.data > 0) {
                            this.$mensagemAvisoSucesso("Registro Incluído.")
                            this.Get();
                            this.Limpar();
                        }
                    });
            }
        },
        Put() {
            if (this.Bairro.baiNome == '') {
                this.$mensagemAviso("Nome Obrigatório.")
            }
            else if (this.Bairro.cpaId == ''){
                this.$mensagemAviso("País Obrigatório.")
            }
            else if (this.Bairro.cetId == ''){
                this.$mensagemAviso("Estado Obrigatório.")
            }
            else if (this.Bairro.cidId == ''){
                this.$mensagemAviso("Cidade Obrigatório.")
            }
            else {
                this.Bairro.CadCidades = { cidId: this.Bairro.cidId};
                this.Bairro.CadEstados = { cetId: this.Bairro.cetId};
                this.Bairro.CadPaises = { cpaId: this.Bairro.cpaId};
                if (this.Bairro.baiAtivo === "" || this.Bairro.baiAtivo === null){
                    this.Bairro.baiAtivo = true;
                }
                axios.put(`/Process/CadBairros/Update`, this.Bairro)
                    .then(response => {
                        if (response.status == 200) {
                            this.$mensagemAvisoSucesso("Registro Alterado.")
                            this.Get();
                            this.Limpar();
                        }
                    });
            }
        },
        async EditGrid(item) {
            // Lógica para editar o item
            this.Bairro = item;
            this.Bairro.cidId = item.cadCidades.cidId
            this.Bairro.cetId = item.cadCidades.cadEstados.cetId
            this.Bairro.cpaId = item.cadCidades.cadEstados.cadPaises.cpaId
            await this.CarregaEstados(item.cadCidades.cadEstados.cadPaises.cpaId)
            await this.CarregaCidades(item.cadCidades.cadEstados.cetId)
            this.$scrollToTop();
        },
        DeleteGrid(item) {

            this.$mensagemConfirma('Tem certeza que deseja excluir?')
            .then((result) => {
            if (result.isConfirmed) {
                // Lógica para excluir o item
                const param1 = item.baiId;
                axios.delete(`/Process/CadBairros/Delete/${param1}`)
                .then(response => {
                    if (response.status == 200) {
                        this.$mensagemAvisoSucesso("Registro Excluido.")
                        this.Get();
                        this.Limpar();
                    }
                });
            }
            });
        },
        CarregaEstados(value) {
            const param1 = value;
            axios.get(`/Process/CadEstados/GetByPaisId/${param1}`)
                .then(response => {
                    this.Estados = response.data.filter(x => x.cetAtivo).sort((a, b) => {
                                                                                    const nomeA = a.cetNome || ""; 
                                                                                    const nomeB = b.cetNome || ""; 
                                                                                    return nomeA.localeCompare(nomeB);
                                                                                    });

                });
        },
        CarregaCidades(value) {
            const param1 = value;
            axios.get(`/Process/CadCidades/GetByEstadoId/${param1}`)
                .then(response => {
                    this.Cidades = response.data.filter(x => x.cidAtivo).sort((a, b) => {
                                                                                    const nomeA = a.cidNome || ""; 
                                                                                    const nomeB = b.cidNome || ""; 
                                                                                    return nomeA.localeCompare(nomeB);
                                                                                    });

                });
        },
        Get() {
            axios.get(`/Process/CadBairros/GetAll`)
                .then(response => {
                    this.Bairros = response.data;
                });
        },
    },
    created() {
        this.Get();
        axios.get(`/Process/CadPaises/GetAll`)
                .then(response => {
                    this.Paises = response.data.filter(x => x.cpaVisivel).sort((a, b) => {
                                                                                    const nomeA = a.cpaNome || ""; 
                                                                                    const nomeB = b.cpaNome || ""; 
                                                                                    return nomeA.localeCompare(nomeB);
                                                                                    });
                });
    },
}
</script>

<style></style>
